import React from "react";
import { connect } from "react-redux";
import {Alert, Layout, Row, Col, notification, Modal, Breadcrumb, Button} from "antd";
import get from "lodash/get";
import map from "lodash/map";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import classes from "./CustomFormCreate.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { customFormCreate } from "../../api/requests";

import { logout } from "../../reducers/user/actions";
import { getCustomFormsCreatePermission } from "../../reducers/user/selectors";

import FormBuilderCustom from "../FormBuilder/FormBuilderCustom";
import FormBuilderCustomView from "../FormBuilder/FormBuilderCustomView";

import { Controlled as CodeMirror } from "react-codemirror2";
require("codemirror/mode/javascript/javascript");

const routes = require("../../routes.json");

const { Content } = Layout;

class CustomFormCreate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      schema: {},
      name: null,
      errors: [],
      isPreviewShow: false,
      schemaEditCodeInitial: null,
      schemaEditCode: null,
      isSchemaEditCode: false,
      schemaErrorMessage: null,
    };
  }

  onSubmit = async (form) => {
    try {
      await customFormCreate(form);

      notification.success({
        message: this.props.i18n.t("Success"),
        description: this.props.i18n.t("Form has been successfully created"),
      });

      this.props.history.push(routes.admin.customFormsList);
    } catch (e) {
      if (get(e, "response.data.error")) {
        this.setState({
          errors: [get(e, "response.data.error")],
        });
      }
      if (Array.isArray(get(e, "response.data"))) {
        this.setState({
          errors: get(e, "response.data"),
        });
      }
      if (get(e, "response.data.fieldName")) {
        this.setState({
          errors: get(e, "response.data.fieldName"),
        });
      }

      notification.error({
        message: "Error",
        description: Array.isArray(get(e, "response.data")) ? get(e, "response.data").join('\n') :''
      });
    }
  };


  onSchemaEdit = (schema, name) => {
    this.setState({ schema: null }, () => {
      this.setState({
        name,
        schemaEditCodeInitial: Object.keys(schema).length === 0 ? null : schema,
        schemaEditCode: Object.keys(schema).length === 0 ? null : schema,
        isSchemaEditCode: true,
      });
    });
  };

  onPreview = (schema, name) => {
    this.setState({ schema: null }, () => {
      this.setState({ schema, name, isPreviewShow: true });
    });
  };

  render() {
    const { schema, name, errors, isPreviewShow,
      schemaEditCode,
      isSchemaEditCode,
      schemaEditCodeInitial,
      schemaErrorMessage, } = this.state;
    const { customFormsCreatePermission } = this.props;

    return (
      <div className={classes.wrapper}>
        <Layout className={classes.parentContainer}>

          <Content className={classes.content}>
            <h3 className="headline-default">{this.props.i18n.t("Create Custom Form")}</h3>

            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={routes.admin.customFormsList}>{this.props.i18n.t("Custom Forms")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{this.props.i18n.t("Create Custom Form")}</Breadcrumb.Item>
            </Breadcrumb>
            <br />

            {customFormsCreatePermission ? (
              <Row>
                <Col span={24}>
                  {!isSchemaEditCode && <FormBuilderCustom
                    initialValues={schemaEditCodeInitial || null}
                    onSchemaEdit={this.onSchemaEdit}
                    onPreview={this.onPreview}
                    onSubmit={this.onSubmit}
                  />}
                </Col>

                <Col span={24}>
                  {errors.length > 0 && (
                    <div className={classes.errorWrapper}>
                      {map(errors, (error, i) => (
                        <Alert
                          message={error}
                          type="error"
                          key={i}
                          style={{ marginTop: "5px" }}
                        />
                      ))}
                    </div>
                  )}
                </Col>
              </Row>
            ) : (
              <Alert message={this.props.i18n.t("Permission denied")} type="error" />
            )}

            {isPreviewShow && (
              <Modal
                title={this.props.i18n.t("Form preview")}
                visible={isPreviewShow}
                onCancel={() => {
                  this.setState({ isPreviewShow: false });
                }}
                footer={null}
                width={640}
              >
                {schema && (
                  <FormBuilderCustomView isEditable schema={schema} name={name} />
                )}
              </Modal>
            )}

            {isSchemaEditCode && (
              <Modal
                title={this.props.i18n.t("Edit schema")}
                visible={isSchemaEditCode}
                onCancel={() => {
                  this.setState({
                    schemaEditCode: null,
                    isSchemaEditCode: false,
                  });
                }}
                footer={null}
                width="90%"
              >
                {isSchemaEditCode && (
                  <div>
                    <CodeMirror
                      editorDidMount={(editor) => {
                        this.editorInstance = editor;
                        this.editorInstance.setSize("100%", "500px");
                      }}
                      value={JSON.stringify(schemaEditCode, null, 2)}
                      onBeforeChange={(editor, data, value) => {
                        this.setState({ schemaEditCode: value });
                      }}
                      options={{
                        mode: {
                          name: "javascript",
                          json: true,
                          statementIndent: 2,
                        },
                        theme: "material",
                        lineNumbers: true,
                        lineWrapping: true,
                        indentWithTabs: false,
                        tabSize: 2,
                      }}
                    />

                    {schemaErrorMessage && (
                      <Alert
                        message={this.props.i18n.t("Invalid JSON format") || schemaErrorMessage}
                        type="error"
                        className={classes.alertResult}
                      />
                    )}

                    <div className={classes.actionWrapper}>
                      <Button
                        type="primary"
                        htmlType="button"
                        className={classes.submitButton}
                        onClick={() => {
                          try {
                            const content = JSON.parse(typeof schemaEditCode === 'string' ? schemaEditCode : JSON.stringify(schemaEditCode));
                            this.setState({
                              schemaEditCodeInitial: content,
                              schemaEditCode: null,
                              schemaErrorMessage: null,
                              isSchemaEditCode: false,
                            });
                          } catch (e) {
                            this.setState({ schemaErrorMessage: e.message });
                          }
                        }}
                      >
                        {this.props.i18n.t("Update schema")}
                      </Button>
                      &nbsp; &nbsp;
                      <Button
                        type="default"
                        htmlType="button"
                        className={classes.submitButton}
                        onClick={() => {
                          this.setState({
                            schemaEditCode: null,
                            schemaErrorMessage: null,
                            isSchemaEditCode: false,
                          });
                        }}
                      >
                        {this.props.i18n.t("Cancel")}
                      </Button>
                    </div>
                  </div>
                )}
              </Modal>
            )}
          </Content>

        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customFormsCreatePermission: getCustomFormsCreatePermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(CustomFormCreate))
);



// WEBPACK FOOTER //
// ./src/containers/CustomFormCreate/CustomFormCreate.js